(() => {
    var e,
        r = {
            988: () => {
                var e,
                    r = 120,
                    t = window.innerWidth;

                function o() {
                    r = window.innerWidth < 768 ? 55 : 80;
                }
                o();

                window.addEventListener("resize", function () {
                    t = window.innerWidth;
                    o();
                    console.log("resize fired");
                });

                document.addEventListener("DOMContentLoaded", function () {
                    gsap.registerPlugin(ScrollTrigger, Observer, MotionPathPlugin);

                    gsap.to(".regular", { duration: 2, x: "0%", y: "0%", ease: "power4.out" });
                    gsap.to(".fck,.soda", { duration: 2, x: "0%", ease: "power4.out" });

                    var o = document.querySelector(".text-wrap"),
                        n = document.querySelector(".sc-text"),
                        i = n ? n.offsetWidth : 0,
                        s = Math.ceil(window.innerWidth / i) + 1;

                    if (n) {
                        for (var a = 0; a < s; a++) {
                            var c = n.cloneNode(true);
                            o.appendChild(c);
                        }
                    }

                    gsap.to(".sc-text", { x: "-100%", duration: 5, repeat: -1, ease: "linear" });
                    gsap.to(".sip-1,.sip-3", { x: "10vw", duration: 1.5, scrollTrigger: { trigger: ".section-5", scrub: true } });
                    gsap.to("#buy-now-btn", {
                        opacity: 1,
                        duration: 0.5,
                        ease: "power2.out",
                        scrollTrigger: { trigger: "#shopify-section-template--19179836178607__custom_liquid_HYPrMV .section-4 .title", start: "bottom bottom", toggleActions: "play none none reverse" }
                    });
                    gsap.to("#buy-now-btn", {
                        opacity: 0,
                        duration: 0.5,
                        ease: "power2.out",
                        scrollTrigger: { trigger: "#info6img", start: "bottom bottom", toggleActions: "play none none reverse" }
                    });
                    gsap.to(".sip-2,.sip-4", { x: "-10vw", duration: 1.5, scrollTrigger: { trigger: ".section-5", scrub: true } });
                    gsap.to(".v-can", {
                        marginTop: t < 768 ? "160px" : "260px",
                        scrollTrigger: {
                            trigger: ".v-can",
                            start: "bottom 50%",
                            endTrigger: "#shopify-section-template--19179836178607__custom_liquid_aRBREM",
                            end: "-20% center",
                            pin: true,
                            scrub: 1,
                            markers: false
                        }
                    });
                    gsap.to(".v-can", {
                        opacity: 0,
                        scrollTrigger: {
                            trigger: "#shopify-section-template--19179836178607__custom_liquid_jz8hfC",
                            start: "center center",
                            endTrigger: "#shopify-section-template--19179836178607__custom_liquid_aRBREM",
                            end: "top center",
                            scrub: 2,
                            markers: false
                        }
                    });

                    gsap.utils.toArray(".info-box").forEach(function (e, o) {
                        var n = (o + 1) * r,
                            i = t < 768 ? 300 : 400;

                        if (o === 6) {
                            gsap.to(e, {
                                scrollTrigger: {
                                    anticipatePin: 1,
                                    trigger: e,
                                    start: `top-=${n} top`,
                                    end: "top center",
                                    endTrigger: ".ib-6",
                                    pin: true,
                                    pinSpacing: false,
                                    scrub: 1,
                                    onEnter: () => console.log("pinned"),
                                },
                            });
                        } else {
                            n -= t < 768 ? 30 : 80;
                            gsap.to(e, {
                                scrollTrigger: {
                                    trigger: e,
                                    start: `top-=${n} top`,
                                    end: `top ${i}`,
                                    endTrigger: ".ib-6",
                                    pin: true,
                                    pinSpacing: false,
                                    scrub: 1,
                                    onEnter: () => console.log("pinned"),
                                },
                            });
                        }

                        gsap.to(e.querySelector("h2"), {
                            scale: t < 768 ? 1 : 0.5,
                            ease: "none",
                            scrollTrigger: { trigger: e, start: "top center", end: "top top", scrub: 1 }
                        });
                    });

                    // ✅ Replacing jQuery with vanilla JS
                    document.querySelectorAll(".xs-accordion .title").forEach((el) => {
                        el.addEventListener("click", () => {
                            const content = el.parentElement.querySelector(".content");
                            if (content) {
                                content.classList.toggle("show");
                            }
                        });
                    });

                    document.querySelectorAll(".footer-accordion h3").forEach((el) => {
                        el.addEventListener("click", () => {
                            const content = el.parentElement.querySelector(".content");
                            if (content) {
                                content.classList.toggle("show");
                            }
                        });
                    });

                    document.getElementById("close-side-menu")?.addEventListener("click", () => {
                        document.getElementById("side-menu")?.classList.remove("active");
                    });

                    document.getElementById("open-side-menu")?.addEventListener("click", () => {
                        document.getElementById("side-menu")?.classList.add("active");
                    });
                });
            },
            547: () => {},
            940: () => {},
        },
        t = {};

    function o(e) {
        var n = t[e];
        if (void 0 !== n) return n.exports;
        var i = (t[e] = { exports: {} });
        return r[e](i, i.exports, o), i.exports;
    }

    (o.m = r),
        (e = []),
        (o.O = (r, t, n, i) => {
            if (!t) {
                var s = 1 / 0;
                for (p = 0; p < e.length; p++) {
                    for (var [t, n, i] = e[p], a = true, c = 0; c < t.length; c++)
                        (!1 & i || s >= i) && Object.keys(o.O).every((e) => o.O[e](t[c]))
                            ? t.splice(c--, 1)
                            : ((a = false), i < s && (s = i));
                    if (a) {
                        e.splice(p--, 1);
                        var g = n();
                        void 0 !== g && (r = g);
                    }
                }
                return r;
            }
            i = i || 0;
            for (var p = e.length; p > 0 && e[p - 1][2] > i; p--) e[p] = e[p - 1];
            e[p] = [t, n, i];
        }),
        (o.o = (e, r) => Object.prototype.hasOwnProperty.call(e, r)),
        (() => {
            var e = { 847: 0, 266: 0, 252: 0 };
            o.O.j = (r) => 0 === e[r];
            var r = (r, t) => {
                    var n,
                        i,
                        [s, a, c] = t,
                        g = 0;
                    if (s.some((r) => 0 !== e[r])) {
                        for (n in a) o.o(a, n) && (o.m[n] = a[n]);
                        if (c) var p = c(o);
                    }
                    for (r && r(t); g < s.length; g++) (i = s[g]), o.o(e, i) && e[i] && e[i][0](), (e[i] = 0);
                    return o.O(p);
                },
                t = (self.webpackChunktailpress = self.webpackChunktailpress || []);
            t.forEach(r.bind(null, 0)), (t.push = r.bind(null, t.push.bind(t)));
        })(),
        o.O(void 0, [266, 252], () => o(988)),
        o.O(void 0, [266, 252], () => o(547));
    var n = o.O(void 0, [266, 252], () => o(940));
    n = o.O(n);
})();
